import React from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import { RouteAuthorizer } from '../../Authorizer'
import CompanyRoutes from './Company'
import AuthorizedOperatorsRoutes from './Operators'
import PlanRoutes from './Plan'
import RolesRoutes from './Roles'
import DownloadDataView from 'components/Management/DownloadDataView'

const AuthorizedCompanyRoutes = RouteAuthorizer(['comunityManager'])(CompanyRoutes)
const AuthorizedPlan = RouteAuthorizer(['operator', 'comunityManager'])(PlanRoutes)
const AuthorizedOperators = RouteAuthorizer(['comunityManager'])(AuthorizedOperatorsRoutes)
const AuthorizedRoles = RouteAuthorizer([])(RolesRoutes)

// eslint-disable-next-line react/display-name
export default ({ match }) => (
  <Switch>
    <Route path={`${match.path}/company`} component={AuthorizedCompanyRoutes} />
    <Route path={`${match.path}/operators`} component={AuthorizedOperators} />
    <Route path={`${match.path}/plan`} component={AuthorizedPlan} />
    <Route path={`${match.path}/roles`} component={AuthorizedRoles} />
    <Route path={`${match.path}/download/data`} component={DownloadDataView} />

    <Route exact path={match.path} render={() => <Redirect to='/' />} />
  </Switch>
)
